export const GET_BESTSELLER_REQUEST = "GET_BESTSELLER_REQUEST";
export const GET_BESTSELLER_SUCCESS = "GET_BESTSELLER_SUCCESS";
export const GET_BESTSELLER_FAILURE = "GET_BESTSELLER_FAILURE";

export const GET_BREAKFAST_REQUEST = "GET_BREAKFAST_REQUEST";
export const GET_BREAKFAST_SUCCESS = "GET_BREAKFAST_SUCCESS";
export const GET_BREAKFAST_FAILURE = "GET_BREAKFAST_FAILURE";

export const GET_FISHDATA_REQUEST = "GET_FISHDATA_REQUEST";
export const GET_FISHDATA_SUCCESS = "GET_FISHDATA_SUCCESS";
export const GET_FISHDATA_FAILURE = "GET_FISHDATA_FAILURE";

export const GET_SEARCH_REQUEST = "GET_SEARCH_REQUEST";
export const GET_SEARCH_SUCCESS = "GET_SEARCH_SUCCESS";
export const GET_SEARCH_FAILURE = "GET_SEARCH_FAILURE";

export const GET_CART_REQUEST = "GET_CART_REQUEST";
export const GET_CART_SUCCESS = "GET_CART_SUCCESS";
export const GET_CART_FAILURE = "GET_CART_FAILURE";

export const POST_CART_REQUEST = "POST_CART_REQUEST";
export const POST_CART_SUCCESS = "POST_CART_SUCCESS";
export const POST_CART_FAILURE = "POST_CART_FAILURE";

export const GET_CARTQUANTITY_REQUEST = "GET_CARTQUANTITY_REQUEST";
export const GET_CARTQUANTITY_SUCCESS = "GET_CARTQUANTITY_SUCCESS";
export const GET_CARTQUANTITY_FAILURE = "GET_CARTQUANTITY_FAILURE";

export const GET_USERPROFILE_REQUEST = "GET_USERPROFILE_REQUEST";
export const GET_USERPROFILE_SUCCESS = "GET_USERPROFILE_SUCCESS";
export const GET_USERPROFILE_FAILURE = "GET_USERPROFILE_FAILURE";